import { inject, Injectable } from '@angular/core';
import {
  createQueryParams,
  IMotorProduct,
  IProductQueryParams,
} from '@inshuwa-client/models';
import { Observable } from 'rxjs';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { IProductsService } from 'libs/core/src/lib/services/products.service';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AdminProductService implements IProductsService {
  private rep = inject(RepresentativeService);

  constructor(private http: HttpClient) {}

  getAllMotorProducts(
    query?: IProductQueryParams,
  ): Observable<IMotorProduct[]> {
    return this.http.get<IMotorProduct[]>(`${baseUrl()}/products/motor`, {
      params: createQueryParams(query),
    });
  }

  deleteProduct(id: number): Observable<unknown> {
    return this.http.delete(`${baseUrl()}/products/${id}`);
  }
}
